import { html } from 'lit';
import type { LandingAction } from '../../shared/content/landingContent.js';
import {
  editorNodeClass,
  editorNodeClick,
  editorNodePointerDown,
  editorNodeStyle,
  type LandingEditorRenderOptions,
} from '../editor/landingEditorRender.js';

interface ActionLinkOptions {
  action: LandingAction;
  variant?: 'primary' | 'secondary' | 'light';
  editor?: LandingEditorRenderOptions;
  elementId?: string;
}

export const actionLink = ({ action, variant = 'primary', editor, elementId }: ActionLinkOptions) => html`
  <a
    class=${`vp-action vp-action-${variant}`}
    href=${action.href}
    @click=${(event: MouseEvent) => {
      if (elementId && editor?.mode === 'editor') event.preventDefault();
    }}
  >
    <span
      class=${elementId ? editorNodeClass(editor, elementId) : ''}
      style=${elementId ? editorNodeStyle(editor, elementId) : ''}
      @pointerdown=${(event: PointerEvent) => elementId && editorNodePointerDown(editor, elementId, event)}
      @click=${(event: MouseEvent) => elementId && editorNodeClick(editor, elementId, event)}
      >${action.label}</span
    >
    <span class="icon-[material-symbols--arrow-outward] vp-action-icon"></span>
  </a>
`;
